export function useInitials(currentAccountUser) {
  if (currentAccountUser.firstName) {
    return currentAccountUser.firstName[0] + currentAccountUser.lastName[0]
  } else {
    return '?'
  }
}
